import { useEffect, useState, useRef } from 'react';
import { useAuthStore } from '../../stores/authStore';

interface AuthInitializerProps {
  children: React.ReactNode;
}

/**
 * Auth initializer component
 * Fetches user info via the /me endpoint before rendering children
 * Ensures auth data is ready before the page renders
 */
export default function AuthInitializer({ children }: AuthInitializerProps) {
  const [isReady, setIsReady] = useState(false);
  const { token, initializeAuth } = useAuthStore();
  const initialized = useRef(false);

  useEffect(() => {
    const init = async () => {
      // Prevent duplicate calls caused by React StrictMode
      if (initialized.current) return;
      initialized.current = true;

      // Only call /me when a token exists
      if (token) {
        await initializeAuth();
      }
      setIsReady(true);
    };

    init();
  }, []); // Empty dependency array — runs only on mount

  // Show loading indicator while initializing
  if (!isReady) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          color: '#6b7280',
        }}
      >
        Loading...
      </div>
    );
  }

  return <>{children}</>;
}
